import { CmsRegisterAnotherAppliancePanel } from '../../models/cms/cms-register-another-appliance-panel.interface';

export const mockCmsRegisterAnotherAppliancePanel: CmsRegisterAnotherAppliancePanel =
  {
    registerAnotherAppliancePanelTitle:
      'Would you like to register another appliance?',
    registerAnotherAppliancePanelExternalUrl:
      'https://www.beko.co.uk/register#slidercell3',
    registerAnotherAppliancePanelBody:
      'Register more appliances now and be the first to know about repairs, recalls and upgrades.',
  };
